import {
  SentimentName,
  SourceNameWithNamespace,
} from 'v2/core/entities/fields';
import { UUID } from 'v2/core/entities/uuid';
import { AtLeastOne } from 'v2/core/typescript/utility';

export interface entityFilter {
  predictedOn?: FilterPredictedOn;
  categories?: string[];
  l1IDs?: UUID[];
  entities: {
    entityID: UUID;
    sentiment?: SentimentName;
  }[];
}
export interface reasonFilter {
  predictedOn?: FilterPredictedOn;
  categories?: string[];
  reasonIDs: UUID[];
}
export interface reviewSentimentFilter {
  sentimentIDs: UUID[];
}

export interface StringMetadataValue {
  type: 'string';
  values: string[];
}
export interface NumberMetadataValue {
  type: 'number';
  values: number[];
}
export interface BooleanMetadataValue {
  type: 'boolean';
  values: boolean[];
}
export type MetadataValue =
  | StringMetadataValue
  | NumberMetadataValue
  | BooleanMetadataValue;
export type MetadataFilter = MetadataValue & {
  key: string;
  operator?: string;
};

export interface SourceFilter {
  sources: SourceNameWithNamespace[];
}

export interface IDFilter {
  ids: string[];
}

export interface labelHierarchyFilter {
  nodeIDs: string[];
}
export interface languageFilter {
  iso6393s: string[];
}
export interface hybridSearchFilter {
  predictedOn?: FilterPredictedOn;
  query: string;
  queries?: string[];
}

export interface categoryFilter {
  categories: string[];
}

export interface FilterPredictedOn {
  isAll: boolean;
  values: string[];
}

export interface l1Filter {
  l1IDs: UUID[];
  categories?: string[];
}

export interface FilterUnion {
  type?: OperationType;
  entityFilter?: entityFilter;
  reasonFilter?: reasonFilter;
  reviewSentimentFilter?: reviewSentimentFilter;
  metadataFilter?: MetadataFilter;
  languageFilter?: languageFilter;
  labelHierarchyFilter?: labelHierarchyFilter;
  sourceFilter?: SourceFilter;
  idFilter?: IDFilter;
  hasReasonFilter?: HasReasonFilter;
  hasAspectFilter?: HasAspectFilter;
  hasClusterFilter?: boolean;
  hasMetadataFilter?: HasMetadataFilter;
  hybridSearchFilter?: hybridSearchFilter;
  hasUserContentFilter?: boolean;
  categoryFilter?: categoryFilter;
  hasSummaryFilter?: boolean;
  l1Filter?: l1Filter;
}

export interface HasReasonFilter {
  predictedOn?: FilterPredictedOn;
  categories?: string[];
}

export interface HasAspectFilter {
  predictedOn?: FilterPredictedOn;
  categories?: string[];
}

export interface HasMetadataFilter {
  keys: string[];
}

export enum OperationType {
  AND = 'AND',
  OR = 'OR',
}
export interface FilterQueryOperation {
  type: OperationType;
  params: WhereClause[];
}
export interface WhereClauseNode {
  filter: FilterUnion;
  op: FilterQueryOperation;
}
export type WhereClause = AtLeastOne<WhereClauseNode> & { exclude?: boolean };

export const EmptyWhereClause: WhereClause = {
  op: {
    type: OperationType.AND,
    params: [],
  },
};
